<template>
  <div class="modal_edit_details">
    <div class="modal_edit_details__header">
      <h4 class="title">
        {{ `${details.device_fid} (${details.device_fid})` }}
        <br>
        {{ details.service_title }}
        <br>
        {{ details.order }}
      </h4>
    </div>

    <div class="modal_edit_details__body">
      <div class="edit_block">
        <div class="line">
          <div class="form_select">
            <WrapDatePicker
                type="date"
                :placeholder="translate('invoice.period_start')"
                :label="translate('invoice.period_start')"
                v-model="new_details.period_start"
                :range="false"
                :disabled_date="['- 3 month', '+ 3 month']"
                value_type="YYYY-MM-DD"
            />
          </div>

          <div class="form_select">
            <WrapDatePicker
                type="date"
                :placeholder="translate('invoice.period_end')"
                :label="translate('invoice.period_end')"
                v-model="new_details.period_end"
                :range="false"
                :disabled_date="['- 3 month', '+ 3 month']"
                value_type="YYYY-MM-DD"
            />
          </div>
        </div>

        <div class="line">
          <div class="form_select">
            <fg-input
                v-model="new_details.cost_without_vat"
                type="number"
                :label="translate('invoice.monthly_cost_without_vat')"
                :placeholder="translate('invoice.monthly_cost_without_vat')"
            />
          </div>

          <div class="form_select">
            <fg-input
                v-model="new_details.sum_without_vat"
                type="number"
                :label="translate('invoice.period_sum_without_vat')"
                :placeholder="translate('invoice.period_sum_without_vat')"
            />
          </div>

        </div>
      </div>
    </div>
    <div class="modal_edit_details__footer">
      <span
          class="btn btn-info btn-fill btn-wd"
          @click.prevent="edit"
      >
        {{ translate('btn.edit') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>

import WrapDatePicker from "../../../../../../../components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'EditDetails',
  props: ['details'],
  components: {
    WrapDatePicker
  },
  data () {
    return {
      new_details: {}
    }
  },
  created() {
    this.new_details = JSON.parse(JSON.stringify(this.details))
    this.new_details.cost_without_vat = Number(this.new_details.price_without_vat)
    this.new_details.sum_without_vat = Number(this.new_details.sum_without_vat)
  },
  methods: {
    edit(){
      const params = {
        period_start: this.new_details.period_start,
        period_end: this.new_details.period_end,
        cost_without_vat: Number(this.new_details.cost_without_vat),
        sum_without_vat: Number(this.new_details.sum_without_vat),
      }
      this.$http.v1.updateInvoiceDetails(this.new_details.id, params, (resp) => {
        if (resp){
          this.global_notify('info', this.translate('invoice.edit_details_success'))
          this.$emit("update")
          this.close_modal()
        } else{
          this.global_notify('danger', this.translate('invoice.edit_details_error'))
        }
      })
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .modal_edit_details{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
      .links{
        width: 30%;
        & > .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }
    &__body{
      width: 100%;
      .edit_block{
        width: 100%;
        height: 100%;
        .line{
          display: flex;
          align-items: flex-start;
          justify-content: space-around;
          .form_select{
            flex: 1;
            margin: 5px;
          }
        }
      }
    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
</style>
